import "@andypf/json-viewer";

import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, computed, input } from "@angular/core";
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from "@angular/material/expansion";
import { ContentBlockCardComponent } from "../../content/cards/content-block-card/content-block-card.component";
import { PlanCardComponent } from "../../content/cards/plan-card/plan-card.component";
import { CONTENT_BLOCK_KINDS } from "../../../model/block.types";
import type { NormalizedContentBlock, ContentBlockData, PlanData } from "../../../model/block.types";

/**
 * Debug-only row for a single `workspace_index_snapshot` entry — a plain content/`plan` block,
 * identical in shape to what the LLM/user would receive for that evidence (content-blocks S5
 * §1.2). Renders the same card component the real dispatcher uses, with no extra wrapper, so it
 * matches the chat UI exactly. Kinds without a dedicated card here (`tool_frontend`/
 * `background_job`/`api_endpoint`) fall back to a raw JSON dump.
 */
@Component({
  selector: "app-workspace-index-card",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, ContentBlockCardComponent, PlanCardComponent],
  templateUrl: "./workspace-index-card.component.html",
  styleUrl: "./workspace-index-card.component.scss",
})
export class WorkspaceIndexCardComponent {
  block = input.required<NormalizedContentBlock>();

  protected readonly contentBlockData = computed((): ContentBlockData | null => {
    const b = this.block();
    return CONTENT_BLOCK_KINDS.has(b.kind) ? (b.data as ContentBlockData) : null;
  });

  protected readonly planData = computed((): PlanData | null => {
    const b = this.block();
    return b.kind === "plan" ? b.data : null;
  });
}
